import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import PrivacyPolicy from "../pages/privacy-policy/page";
import TermsOfService from "../pages/terms-of-service/page";
import CookiePolicy from "../pages/cookie-policy/page";
import MarketAnalysis from "../pages/solutions/market-analysis/page";
import LeadEnablement from "../pages/solutions/lead-enablement/page";
import BusinessIntelligence from "../pages/solutions/business-intelligence/page";
import StrategicSupport from "../pages/solutions/strategic-support/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicy />,
  },
  {
    path: "/terms-of-service",
    element: <TermsOfService />,
  },
  {
    path: "/cookie-policy",
    element: <CookiePolicy />,
  },
  {
    path: "/solutions/market-analysis",
    element: <MarketAnalysis />,
  },
  {
    path: "/solutions/lead-enablement",
    element: <LeadEnablement />,
  },
  {
    path: "/solutions/business-intelligence",
    element: <BusinessIntelligence />,
  },
  {
    path: "/solutions/strategic-support",
    element: <StrategicSupport />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;